export default "__VITE_ASSET__a4f3ed87__"